module.exports = __webpack_public_path__ + "static/media/hidden-company-info.cab402ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/upsell/hidden-company-info.png
// module id = X2dd
// module chunks = 89